import React from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import DateTd from "../table-componets/DateTd.js";
import LinkTd from "../table-componets/LinkTd.js";
import { DATE } from "../../utils/dateFormats";

const CertificationIndexRow = ({
  certification,
  index,
  handlerDelete,
  openEditModal
}) => (
  <tr key={index}>
    <td>
      {certification.certification_type &&
        <span>{certification.certification_type.name}</span>
      }
      <span>
        {certification.attachment_file_size != null ? (
          <a
            href={certification.attachment_url}
            className="styled-link pointer-hand"
            target="_blank"
          >
            <span className="material-icons md-20 icon-for-btn">
              attachment
            </span>
          </a>
        ) : (
          <span />
        )}
      </span>
      {certification.provider_certification_id ? (
        <div className="hidden visible-xs visible-sm">
          <span data-tip={certification.provider_certification_id}>
            <i className="material-icons">confirmation_number</i>
            <ReactTooltip />
          </span>
        </div>
      ) : null}
    </td>
    <td className="hidden-xs hidden-sm">
      {certification.provider_certification_id
        ? certification.provider_certification_id
        : "-"}
    </td>
    <LinkTd
      fieldName={
        certification.user.last_name +
        ", " +
        certification.user.first_name
      }
      fieldURL={"/users/" + certification.user_id}
      fieldClassName="visible-xs visible-sm"
    />
    <LinkTd
      fieldName={certification.user.last_name}
      fieldURL={"/users/" + certification.user_id}
      fieldClassName="hidden-xs hidden-sm"
    />
    <LinkTd
      fieldName={certification.user.first_name}
      fieldURL={"/users/" + certification.user_id}
      fieldClassName="hidden-xs hidden-sm"
    />
    <DateTd
      fieldValue={certification.issue_date}
      fieldFormat={DATE}
      fieldClassName="hidden-xs hidden-sm"
      fieldInsideClassName="pull-right"
    />
    <DateTd
      fieldValue={certification.expiration_date}
      fieldFormat={DATE}
      fieldClassName={certification.expiration_date_color}
      fieldInsideClassName="pull-right"
    />
    <td>
      <a
        href="#"
        className="btn btn-text pull-right"
        onClick={() => {
          handlerDelete(certification);
        }}
      >
        DELETE
      </a>
      <a href="#"
        className="btn btn-text pull-right"
        onClick={() => openEditModal(certification, index)}
      >
        EDIT
      </a>
    </td>
  </tr>
);

const StandardCertificationsIndex = ({
  certifications,
  sortData,
  handlerDelete,
  openEditModal
}) => (
  <table className="table table-clean table-white">
    <thead>
      <tr>
        <th>
          <a
            onClick={(e) => { e.preventDefault(); sortData("name"); }}
            className="styled-link pointer-hand"
            role="button"
            aria-label="Sort by Certification"
            tabIndex="0"
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                sortData("name");
              }
            }}
          >
            Certification
          </a>
        </th>

        <th className="hidden-xs hidden-sm">
          <a
            onClick={(e) => { e.preventDefault(); sortData("provider_certification_id"); }}
            className="styled-link pointer-hand"
            role="button"
            aria-label="Sort by Provider Certification ID"
            tabIndex="0"
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                sortData("provider_certification_id");
              }
            }}
          >
            Provider<br />Certification ID
          </a>
        </th>

        <th className="visible-xs visible-sm">
          <a
            onClick={(e) => { e.preventDefault(); sortData("users-last_name"); }}
            className="styled-link pointer-hand"
            role="button"
            aria-label="Sort by Name"
            tabIndex="0"
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                sortData("users-last_name");
              }
            }}
          >
            Name
          </a>
        </th>

        <th className="hidden-xs hidden-sm">
          <a
            onClick={(e) => { e.preventDefault(); sortData("users-last_name"); }}
            className="styled-link pointer-hand"
            role="button"
            aria-label="Sort by Last Name"
            tabIndex="0"
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                sortData("users-last_name");
              }
            }}
          >
            Last Name
          </a>
        </th>

        <th className="hidden-xs hidden-sm">
          <a
            onClick={(e) => { e.preventDefault(); sortData("users-first_name"); }}
            className="styled-link pointer-hand"
            role="button"
            aria-label="Sort by First Name"
            tabIndex="0"
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                sortData("users-first_name");
              }
            }}
          >
            First Name
          </a>
        </th>

        <th className="hidden-xs hidden-sm">
          <span className="pull-right">
            <a
              onClick={(e) => { e.preventDefault(); sortData("issue_date"); }}
              className="styled-link pointer-hand"
              role="button"
              aria-label="Sort by Issue Date"
              tabIndex="0"
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  sortData("issue_date");
                }
              }}
            >
              Issue Date
            </a>
          </span>
        </th>

        <th>
          <span className="pull-right">
            <a
              onClick={(e) => { e.preventDefault(); sortData("expiration_date"); }}
              className="styled-link pointer-hand"
              role="button"
              aria-label="Sort by Expiration Date"
              tabIndex="0"
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  sortData("expiration_date");
                }
              }}
            >
              Expiration Date
            </a>
          </span>
        </th>
        <th />
      </tr>
    </thead>
    <tbody>
      {certifications.map((certification, index) => (
        <CertificationIndexRow
          key={index}
          certification={certification}
          index={index}
          handlerDelete={handlerDelete}
          openEditModal={openEditModal}
        />
      ))}
    </tbody>
  </table>
);

StandardCertificationsIndex.propType = {
  value: PropTypes.string,
  name: PropTypes.string
};

export default StandardCertificationsIndex;
